import hasAudioPermissions from 'APP/Tasks/permissions/hasAudioPermissions';
import hasMediaPermissions from 'APP/Tasks/permissions/hasMediaPermissions';

import { getAudioPermission } from './getAudioPermission';
import { getVideoPermission } from './getVideoPermission';
import hasCameraPermission from './hasCameraPermission';
import hasMicrophonePermission from './hasMicrophonePermission';
import { hasCamera } from './mediaDevices/hasCamera';
import { hasMicrophone } from './mediaDevices/hasMicrophone';

export default {
  hasMicrophonePermission,
  hasCameraPermission,
  hasAudioPermissions,
  hasMediaPermissions,
  hasCamera,
  hasMicrophone,
  getAudioPermission,
  getVideoPermission,
};
